export default __webpack_public_path__ + "static/media/criancas.dd861b9b.png";